export default __webpack_public_path__ + "static/media/warning.0efb223e.svg";